import React, { useRef, useState } from "react";
import { message } from "antd";
import { motion } from "framer-motion";
import API from "../utils/api";

const BulkUploadButton = ({ onSuccess }) => {
  const inputRef = useRef(null);
  const [btnLoading, setBtnLoading] = useState(false);

  const openPicker = () => inputRef.current?.click();

  const uploadExcel = async (file) => {
    setBtnLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);

      const res = await API.post("/manager/ttl/bulk-upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      message.success(res.data?.message || "Bulk upload successful ✅");
      onSuccess?.();
    } catch (error) {
      console.error("Bulk upload error:", error);
      message.error(error?.response?.data?.message || "Bulk upload failed");
    } finally {
      setBtnLoading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const ok =
      file.name.endsWith(".xlsx") ||
      file.name.endsWith(".xls") ||
      file.name.endsWith(".csv");

    if (!ok) {
      message.error("Please upload a valid Excel/CSV file");
      return;
    }

    uploadExcel(file);
  };

  return (
    <>
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={openPicker}
        disabled={btnLoading}
        className="relative overflow-hidden px-6 py-[4px] rounded-lg font-semibold text-indigo-500 ring-[1px] ring-blue-700 bg-white hover:bg-indigo-600 hover:text-white disabled:opacity-70"
      >
        <motion.span
          initial={{ x: "-100%" }}
          whileHover={{ x: "100%" }}
          transition={{ duration: 0.65 }}
          className="absolute inset-0 bg-gradient-to-r from-transparent via-red-500 to-transparent"
        />
        {btnLoading ? "Uploading..." : "Add Sallers"}
      </motion.button>

      <input
        ref={inputRef}
        type="file"
        accept=".xlsx,.xls,.csv"
        hidden
        onChange={handleFileChange}
      />
    </>
  );
};

export default BulkUploadButton;
